import React, { useState, useEffect } from "react";
import "./Matrix.css"


const Matrix = () => {

    const [columns, setColumns] = useState([]);

    useEffect(() => {
        const columnCount = Math.floor(window.innerWidth / 20); // 1列あたり20px幅
        const cols = Array.from({ length: columnCount }, () => generateColumn());
        setColumns(cols);
    }, []);

    // ランダムな文字列を生成する関数
    const generateColumn = () => {
        const characters = "ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789abcdefghijklmnopqrstuvwxyzアオヤマタロウアオヤマタロウアオヤマタロウアオヤマタロウアオヤマタロウアオヤマタロウアオヤマタロウアオヤマタロウアオヤマタロウアオヤマタロウアオヤマタロウ♡♡♡♡♡♡♡♡♡♡♡♡♡♡♡♡";
        const length = Math.floor(Math.random() * 20) + 10; // 10～30文字
        return Array.from({ length }, () =>
            characters.charAt(Math.floor(Math.random() * characters.length))
        ).join("");
    };


    return (
        <div className="matrix-container">
            {columns.map((column, index) => (
                <div className="matrix-column" key={index}>
                    {column.split("").map((char, charIndex) => (
                        <span
                            className="matrix-char"
                            style={{
                                animationDelay: `${Math.random() * 2}s`,
                                animationDuration: `${Math.random() * 2 + 2}s`,
                            }}
                            key={charIndex}
                        >
                            {char}
                        </span>
                    ))}
                </div>
            ))}
        </div>
    );


}


export default Matrix;